import { FC, ReactNode, useEffect } from 'react'
import { CategoryState, ComponentState, SideoverState, TagState } from '@/states'
import { useNotification } from '@/hooks'
import { Create as CreateComponent, Update as UpdateComponent } from '@/controllers/component'
import { Create as CreateTag, Update as UpdateTag } from '@/controllers/tag'
import { Create as CreateCategory, Update as UpdateCategory } from '@/controllers/category'

const Buttons: FC = (): ReactNode => {
    const { InitNotification } = useNotification()
    const { SetState, Form, Errors, Mode, Target, Open } = SideoverState()
    const { SetState: SetTagsState, Tags } = TagState()
    const { SetState: SetCategoryState, Categories } = CategoryState()
    const { SetState: SetComponentState } = ComponentState()

    const HandleSubmit = () => {
        if (Target === 'component') CreateComponent({
            Form,
            Errors,
            SetComponentState,
            SetState,
            InitNotification
        })

        if (Target === 'tag') CreateTag({
            Tags,
            SetTagsState,
            Form,
            Errors,
            SetState,
            InitNotification
        })

        if (Target === 'category') CreateCategory({
            Categories,
            SetCategoryState,
            Form,
            Errors,
            SetComponentState,
            SetState,
            InitNotification
        })
    }

    const HandleUpdate = () => {
        if (Target === 'component') UpdateComponent({
            Form,
            Errors,
            SetComponentState,
            SetState,
            InitNotification
        })

        if (Target === 'tag') UpdateTag({
            Tags,
            SetTagsState,
            Form,
            Errors,
            SetState,
            InitNotification
        })

        if (Target === 'category') UpdateCategory({
            Categories,
            SetCategoryState,
            Form,
            Errors,
            SetComponentState,
            SetState,
            InitNotification
        })
    }

    const entity = Target.charAt(0).toUpperCase() + Target.slice(1)

    useEffect(() => {
        const HandleEnter = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && Open) {
                if (Mode === 'create') HandleSubmit()
                if (Mode === 'edit') HandleUpdate()
            }
        }

        window.addEventListener('keydown', HandleEnter)
        return () => window.removeEventListener('keydown', HandleEnter)
    })

    return (
        <div className='w-full flex justify-end gap-2 border-t border-[#424242]'>
            {
                Mode === 'create' &&
                <button onClick={HandleSubmit} className='select-none flex mt-4 button-gradient items-center justify-center w-full px-4 py-2 text-sm font-medium text-[#EBEBEB] rounded-md md:w-auto hover:opacity-90  transition-all ease-in-out duration-500'>
                    Save {entity}
                </button>
            }

            {
                Mode === 'edit' &&
                <button onClick={HandleUpdate} className='select-none flex mt-4 button-gradient items-center justify-center w-full px-4 py-2 text-sm font-medium text-[#EBEBEB] rounded-md md:w-auto hover:opacity-90  transition-all ease-in-out duration-500'>
                    Update {entity}
                </button>
            }
        </div>
    )
}

export default Buttons
